/**
 * PublicLayer — mirrors ConneXt v2 CommonLayer.
 * Exposes top-level methods on window.Connext / window.CnnXt.
 */
import { getVersionInfo } from '@Engage.Core';
import { AppOptions } from '../../application/options/AppOptions';
import { PublicStorageModel } from './PublicStorageModel';
import { DebugPanel } from '../../plugins/engage/debug/DebugPanel';
export class PublicLayer {
    constructor() {
        this.DisplayName = "ConneXt";
        this.USER_STATES = {
            LoggedOut: 'LoggedOut',
            LoggedIn: 'LoggedIn',
            Subscribed: 'Subscribed',
            SubscribedNotEntitled: 'SubscribedNotEntitled',
            NoActiveSubscription: 'NoActiveSubscription'
        };
        this.Storage = new PublicStorageModel();
    }
    GetVersionInfo() {
        return getVersionInfo();
    }
    GetOptions() {
        var _a, _b;
        return {
            SiteCode: AppOptions.getSiteCode(),
            ConfigCode: AppOptions.getConfigCode(),
            Environment: ((_a = AppOptions.getEnvironment) === null || _a === void 0 ? void 0 : _a.call(AppOptions)) || '',
            ClientCode: ((_b = AppOptions.getClientCode) === null || _b === void 0 ? void 0 : _b.call(AppOptions)) || ''
        };
    }
    CloseTemplates() {
        document.querySelectorAll('.engage-template.Mg2-connext').forEach(el => el.remove());
        document.querySelectorAll('.connext-modal-backdrop, .engage-backdrop').forEach(el => el.remove());
        document.querySelectorAll('.modal-scrollable').forEach(el => el.remove());
        document.body.style.overflow = '';
        document.body.classList.remove('page-overflow');
    }
    IntegrateProduct() {
        document.querySelectorAll('.engage-paywall-mask, .ga-paywall-backdrop, .ga-paywall').forEach(el => el.remove());
        document.body.style.overflow = '';
    }
    Logout() {
        document.dispatchEvent(new CustomEvent('onLogout'));
    }
    /** Toggle the debug panel — mirrors ConneXt v2 AppOptions.setDebugMode() */
    debug() {
        DebugPanel.toggle();
    }
}
